export default {
  applyRentFilter({ commit }, item) {
    commit("APPLY_RENT_FILTER", item);
  },
  setRentSearchQuery({ commit }, query) {
    commit("SET_RENT_SEARCH_QUERY", query);
  },
  resetRentFilter({ commit }) {
    commit("RESET_RENT_FILTER");
  },
  applyRentFilterToggle({ commit }, item) {
    commit("APPLY_RENT_FILTER_TOGGLE", item);
  },
  setRefine({ commit }, value) {
    commit("SET_REFINE", value);
  },
  setRentList({ commit }, item) {
    commit("SET_RENT_LIST", item);
  },
  soldPointer({ commit }, item) {
    commit("SOLD_POINTER", item);
  }, 
  soldAuthPointer({ commit }, item) {
    commit("SOLD_AUTH_POINTER", item);
  },
  addAuthPointer({ commit }, item) {
    commit("ADD_AUTH_POINTER", item);
  },
  setAuthPointerList({ commit }, query) {
    commit("SET_AUTH_POINTER", query);
  },
};
